import AuthorsApi from '@/frontend/api/authors';
export default {
  name: "AuthorsByAlpComponent",
  props: {
    search: String
  },

  data() {
    return {
      AuthorNames: []
    };
  },

  computed: {
    Authors() {
      let cols = [{}, {}, {}],
          colNum = 0,
          colCount = 0,
          colCount2 = 0,
          authors = Object.assign({}, this.filteredAuthors);

      for (let key in authors) {
        for (let key2 in authors) {
          colCount += authors[key2].length;
        }

        for (let key3 in cols[colNum]) {
          colCount2 += cols[colNum][key3].length;
        }

        if (colNum === 2 || colNum === 0 && colCount2 < colCount / 2 || colNum === 1 && colCount2 < colCount) {
          if (!Array.isArray(cols[colNum][key])) cols[colNum][key] = [];
          cols[colNum][key] = authors[key];
          delete authors[key];
        } else {
          colNum += 1;
          if (!Array.isArray(cols[colNum][key])) cols[colNum][key] = [];
          cols[colNum][key] = authors[key];
          delete authors[key];
        }

        colCount2 = 0;
        colCount = 0;
      }

      return cols;
    },

    filteredAuthors() {
      let result = {};
      if (!this.AuthorNames.length) return result;
      this.AuthorNames.forEach(item => {
        let char = item.name[0];

        if (!this.search || item.name.toUpperCase().indexOf(this.search.toUpperCase()) !== -1) {
          if (!Array.isArray(result[char])) result[char] = [];
          result[char].push({
            id: item.id,
            name: item.name
          });
        }
      });
      return result;
    }

  },

  created() {
    AuthorsApi.getNames().then(response => this.AuthorNames = response);
  }

};